// import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './ListTabs.module.scss';

const ListTabs = ({ tabs, activeTab, onTabSwitch }) => {
    return (
        <div className={styles['ListTabs']}>
            <div
                className={styles['ListTabs__TabBar']}
                role="tablist"
                aria-label="List tabs"
            >
                {tabs &&
                    tabs.map((tab) => (
                        <button
                            key={`tab-${tab.id}`}
                            id={`tab-${tab.id}`}
                            aria-selected={activeTab === tab.id}
                            aria-controls={`panel-${tab.id}`}
                            role="tab"
                            type="button"
                            className={styles['ListTabs__Tab']}
                            onClick={() => onTabSwitch(tab.id)}
                        >
                            {tab.tabTitle}
                        </button>
                    ))}
            </div>
            <div className={styles['ListTabs__Content']}>
                {tabs &&
                    tabs.map((tab) => (
                        <div
                            key={`panel-${tab.id}`}
                            id={`panel-${tab.id}`}
                            aria-hidden={activeTab !== tab.id}
                            aria-labelledby={`tab-${tab.id}`}
                            role="tabpanel"
                            className={classNames(styles['ListTabs__Panel'], {
                                [styles['ListTabs__Panel--Active']]:
                                    activeTab === tab.id,
                            })}
                        >
                            {tab.content}
                        </div>
                    ))}
            </div>
        </div>
    );
};

ListTabs.propTypes = {};

export default ListTabs;
